import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";

/* TimestampToDate 接受三個參數 返回格式化的日期時間
1.timestamp 時間戳：毫秒為單位
2.time_zone 時區
3.full 這裡用於顯示秒數，預設為 false，若填入 true 則顯示 秒數*/
export const TimestampToDate = (timestamp: number, time_zone: string, full: boolean = false) => {
  // 使用 Luxon 套件中的 DateTime 類來處理日期和時間，fromMillis 方法接受的是以毫秒為單位的時間戳（timestamp）
  const test = DateTime.fromMillis(timestamp, { zone: time_zone });
  // 構建日期和時間信息為字符串
  // toString() = 轉為字串
  // padStart(2, "0") = 字串的長度填充至指定的位數，不足時補"0" 例：console.log('9'.padStart(2,'0')); 結果： '09'
  return `${test.year}-${test.month}-${test.day} ${test.hour.toString().padStart(2, "0")}:${test.minute
    .toString()
    .padStart(2, "0")}${full ? ":" + test.second.toString().padStart(2, "0") : ""}`;
};

// add a leading zero to a month 1-9
export const TimestampToDateM = (timestamp: number, time_zone: string, full: boolean) => {
  const test = DateTime.fromMillis(timestamp, { zone: time_zone });
  return (
    `${test.year}-${test.month.toString().padStart(2, "0")}-${test.day.toString().padStart(2, "0")}` +
    ` ` +
    `${test.hour.toString().padStart(2, "0")}:${test.minute.toString().padStart(2, "0")}` +
    `${full ? ":" + test.second.toString().padStart(2, "0") : ""}`
  );
};

export const TimestampToDateOnly = (timestamp: number, time_zone: string, full: boolean = false) => {
  const test = DateTime.fromMillis(timestamp, { zone: time_zone });
  return `${test.year}-${test.month.toString().padStart(2, "0")}-${test.day.toString().padStart(2, "0")}`;
};

// 定義 (接收秒數參數)函數，將秒數帶入進去後自動 return 回傳 天數、小時、分鐘、秒數
export const Uptime = (seconds: number) => {
  if (seconds === 0) {
    return 0;
  }

  seconds = Number(seconds);
  var d = Math.floor(seconds / (3600 * 24)); //取得天數
  var h = Math.floor((seconds % (3600 * 24)) / 3600); //取得小時數
  var m = Math.floor((seconds % 3600) / 60); //取得分鐘數
  var s = Math.floor(seconds % 60); //取得秒數

  var dDisplay = d > 0 ? d + (d == 1 ? " day, " : " days, ") : "";
  var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
  var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
  var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
  return dDisplay + hDisplay + mDisplay + sDisplay;
};

//////////////////////////////////////////////////////////////////////////
// 連線時間函數
export const ConnectionTime = (seconds: number, day: string, second: string) => {
  let daySec = 24 * 60 * 60;
  let hourSec = 60 * 60;
  let minuteSec = 60;
  let dd = Math.floor(seconds / daySec);
  let hh = Math.floor((seconds % daySec) / hourSec);
  let mm = Math.floor((seconds % hourSec) / minuteSec);
  let ss = seconds % minuteSec;
  if (dd > 0) {
    return (
      dd +
      " " +
      day +
      " " +
      hh.toString().padStart(2, "0") +
      ":" +
      mm.toString().padStart(2, "0") +
      ":" +
      ss.toString().padStart(2, "0")
    );
  } else if (hh > 0) {
    return hh.toString().padStart(2, "0") + ":" + mm.toString().padStart(2, "0") + ":" + ss.toString().padStart(2, "0");
  } else if (mm > 0) {
    return mm.toString().padStart(2, "0") + ":" + ss.toString().padStart(2, "0");
  } else {
    // return ss.toString().padStart(2, "0") + t("ISMS.Second");
    return ss.toString() + " " + second;
  }
};
